import { useAuthUserContext } from 'app/core/security/authSession';
import { type Icon, Stars, Sun, Sunrise, Sunset } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

interface GreetingInfo {
  key: string;
  icon: Icon;
  color: string;
  bg: string;
}

function getGreetingInfo(date = new Date()): GreetingInfo {
  const hour = date.getHours();

  if (hour >= 5 && hour < 12) {
    return {
      key: 'morning',
      icon: Sunrise,
      color: '#F5A400',
      bg: '#FFF7E0'
    };
  }

  if (hour >= 12 && hour < 17) {
    return {
      key: 'afternoon',
      icon: Sun,
      color: '#F59E0B',
      bg: '#FFF4D6'
    };
  }

  if (hour >= 17 && hour < 21) {
    return {
      key: 'evening',
      icon: Sunset,
      color: '#8B5CF6',
      bg: '#F3EEFF'
    };
  }

  return {
    key: 'night',
    icon: Stars,
    color: '#3B6FD8',
    bg: '#EEF3FF'
  };
}

export const HelloUser = () => {
  const { t } = useTranslation();
  const context = useAuthUserContext();

  const greeting: GreetingInfo = getGreetingInfo();
  const name = context?.userProfile?.name?.trim();

  return (
    <>
      <div
        className="card py-3"
        style={{
          ...(greeting.bg != null && { backgroundColor: greeting.bg })
        }}
      >
        <div className="card-body">
          <div className="d-flex align-items-start gap-3 mt-0 mb-3">
            <greeting.icon
              size="3rem"
              style={{
                ...(greeting.color != null && { color: greeting.color })
              }}
            />
            <div className="ps-3">
              <div className={`text-body-secondary fs-3`}>{t('greetings.' + greeting.key)}</div>
              <div className="text-dark fs-1 fw-bolder"> {name ? `${name}` : ''} </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
